import Euler, {
  EulerTouchableOpacityProps,
  EulerViewProps,
} from '@euler/components/layout';
import EulerTouchableOpacity from '@euler/components/layout/TouchableOpacity';
import { FC, memo } from 'react';

const CenterImpl = memo(
  ({
    justifyContent = 'center',
    alignItems = 'center',
    ...props
  }: EulerViewProps) => {
    return (
      <Euler.View
        justifyContent={justifyContent}
        alignItems={alignItems}
        {...props}
      />
    );
  },
);

export const Center = CenterImpl as unknown as FC<EulerViewProps> & {
  Touchable: FC<EulerTouchableOpacityProps>;
};

Center.Touchable = memo(
  ({
    justifyContent = 'center',
    alignItems = 'center',
    ...props
  }: EulerTouchableOpacityProps) => {
    return (
      <EulerTouchableOpacity
        justifyContent={justifyContent}
        alignItems={alignItems}
        {...props}
      />
    );
  },
);
